import { NavLink, useNavigate } from "react-router-dom";
import { useResourcePersonAuth } from "../store/resourcePerson/resourcePersonStore";
import useAssessmentBadge from "../hooks/useAssessmentBadge";
import {
  LayoutDashboard,
  BookOpen,
  ClipboardCheck,
  User,
  LogOut,
  Library,
  FileText,
  Landmark,
  Store,
} from "lucide-react";

import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarFooter,
} from "./ui/sidebar";

const menuItems = [
  { title: "Dashboard", url: "/resource-person/dashboard", icon: LayoutDashboard },
  { title: "Content Library", url: "/resource-person/content-library", icon: BookOpen },
  { title: "Assessment", url: "/resource-person/assessment", icon: ClipboardCheck },
  { title: "Book Upload", url: "/resource-person/book-upload", icon: Library },
  { title: "Journals Upload", url: "/resource-person/journals", icon: FileText },
  { title: "More Resources", url: "/resource-person/marketplace", icon: Store },
  { title: "Support", url: "/resource-person/support", icon: BookOpen },
  { title: "Subscriptions", url: "/resource-person/subscriptions", icon: LayoutDashboard },
  { title: "Bank Details", url: "/resource-person/bank-details", icon: Landmark },
  { title: "Withdrawals", url: "/resource-person/withdrawals", icon: LayoutDashboard },
  { title: "Profile", url: "/resource-person/account/settings", icon: User },
];

export function AppSidebar() {
  const navigate = useNavigate();
  const { logout } = useResourcePersonAuth();
  const { count: pendingAssessments } = useAssessmentBadge();
  
  const handleLogout = async () => {
    await logout();
    localStorage.removeItem("isAdmin");
    navigate("/resource-personlogin");
  };
  return (
    <Sidebar className="border-r border-white/10 bg-sidebar">
      
      {/* Header */}
      <SidebarHeader className="flex flex-col items-start gap-3 border-b border-white/10 px-3 pb-6 pt-7">
        <div className="flex items-center gap-2">
          <img
            src="/images/logo.png"
            alt="Fillop"
            className="h-9 w-9 rounded-lg object-contain"
          />
          <span className="text-2xl text-white">Fillop</span>
        </div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold tracking-wide text-white ring-1 ring-white/15">
          <User className="text-[11px] text-white" />
          Resource Person
        </span>
      </SidebarHeader>

      {/* Navigation */}
      <SidebarContent className="flex-1 overflow-y-auto px-0 py-1 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
        <ul className="flex flex-1 flex-col gap-1 px-1">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const badge = item.title === "Assessment" ? pendingAssessments : 0;

            return (
              <li key={item.title}>
                <NavLink
                  to={item.url}
                  end
                  className={({ isActive }) =>
                    `group flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm no-underline transition-colors ${
                      isActive
                        ? "bg-white/10 font-semibold text-white"
                        : "text-slate-300 hover:bg-white/5 hover:text-white"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      <Icon
                        className={`h-4 w-4 shrink-0 ${
                          isActive ? "text-white" : "text-slate-400 group-hover:text-white/50"
                        }`}
                      />
                      <span className="min-w-0 flex-1 truncate">{item.title}</span>
                      {badge > 0 ? (
                        <span className="ml-auto min-w-5 rounded-full bg-rose-500 px-1.5 py-0.5 text-center text-[10px] font-bold text-white">
                          {badge > 99 ? "99+" : badge}
                        </span>
                      ) : null}
                    </>
                  )}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </SidebarContent>

      {/* Footer */}
      <SidebarFooter className="border-t border-white/10 p-1">
        <button
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-slate-300 transition-colors hover:bg-white/5 hover:text-red-400"
        >
          <LogOut className="h-4 w-4 shrink-0" />
          <span>Logout</span>
        </button>
      </SidebarFooter>

    </Sidebar>
  );
}
